import { render } from "./successPaye.vue?vue&type=template&id=17a66be0&scoped=true"
import script from "./successPaye.vue?vue&type=script&lang=js"
export * from "./successPaye.vue?vue&type=script&lang=js"

import "./successPaye.vue?vue&type=style&index=0&id=17a66be0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a66be0"]])

export default __exports__